<script context="module" lang="ts"></script>

<script lang="ts">
    import Preview from "$lib/image/Preview.svelte";
    import type { File } from "$lib/wasm/file";

    export let file: File;
    export let frame = 0;

</script>

<!----------------------------------------------------------------------------->


<Preview {file} {frame} />

<!----------------------------------------------------------------------------->
